module.exports = __webpack_public_path__ + "static/studio-07-452d211e4abe5d1a0d1e802055940757.jpeg";